import React from 'react';
import { isHtmlContent, sanitizeRichHtml } from '../utils/richText';
import './rich-text-content.css';

export default function RichTextContent({ content, className = '', style = {} }) {
  if (!content?.trim()) return null;

  if (isHtmlContent(content)) {
    return (
      <div
        className={`rich-text-content ${className}`.trim()}
        style={style}
        dangerouslySetInnerHTML={{ __html: sanitizeRichHtml(content) }}
      />
    );
  }

  return (
    <div className={`rich-text-content rich-text-content--plain ${className}`.trim()} style={style}>
      {content}
    </div>
  );
}
